/**
 * jQuery 4.0 Compatibility Shim
 *
 * jQuery 4.0 removed several deprecated APIs. This shim restores the most
 * commonly used ones as thin wrappers around their modern equivalents so
 * legacy code and third-party libraries that still reference them keep
 * working. It is loaded immediately after jQuery in the layout.
 */
(function () {
  'use strict';

  if (typeof jQuery === 'undefined') return;

  var $ = jQuery;

  // $.type -> typeof with object/array detection
  if (!$.type) {
    var class2type = {};
    ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Object', 'Error', 'Symbol', 'BigInt']
      .forEach(function (name) {
        class2type['[object ' + name + ']'] = name.toLowerCase();
      });

    $.type = function (obj) {
      if (obj == null) return String(obj);
      return typeof obj === 'object' || typeof obj === 'function'
        ? (class2type[Object.prototype.toString.call(obj)] || 'object')
        : typeof obj;
    };
  }

  // $.isFunction -> typeof check
  if (!$.isFunction) {
    $.isFunction = function (obj) {
      return typeof obj === 'function';
    };
  }

  // $.isWindow
  if (!$.isWindow) {
    $.isWindow = function (obj) {
      return obj != null && obj === obj.window;
    };
  }

  // $.isArray -> Array.isArray
  if (!$.isArray) {
    $.isArray = Array.isArray;
  }

  // $.trim -> String.prototype.trim
  if (!$.trim) {
    $.trim = function (text) {
      return text == null ? '' : String.prototype.trim.call(text);
    };
  }

  // $.parseJSON -> JSON.parse
  if (!$.parseJSON) {
    $.parseJSON = JSON.parse;
  }

  // $.unique -> uniqueSort (renamed in 3.x, removed in 4.x)
  if (!$.unique && $.uniqueSort) {
    $.unique = $.uniqueSort;
  }

  // $.nodeName
  if (!$.nodeName) {
    $.nodeName = function (elem, name) {
      return elem && elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    };
  }

  // Event shortcuts: .bind / .unbind
  if (!$.fn.bind) {
    $.fn.bind = function (types, data, fn) {
      return this.on(types, null, data, fn);
    };
  }
  if (!$.fn.unbind) {
    $.fn.unbind = function (types, fn) {
      return this.off(types, null, fn);
    };
  }

  // .delegate / .undelegate
  if (!$.fn.delegate) {
    $.fn.delegate = function (selector, types, data, fn) {
      return this.on(types, selector, data, fn);
    };
  }
  if (!$.fn.undelegate) {
    $.fn.undelegate = function (selector, types, fn) {
      return this.off(types, selector, fn);
    };
  }

  // .size() -> .length
  if (!$.fn.size) {
    $.fn.size = function () {
      return this.length;
    };
  }

  // .ready(fn) -> $(fn)
  if (!$.fn.ready) {
    $.fn.ready = function (fn) {
      if (typeof fn === 'function') {
        $(fn);
      }
      return this;
    };
  }
})();
